/* titleBoxComponents-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./titleBoxComponents-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { fg } from '@atlaskit/platform-feature-flags';
import { N0, N800 } from '@atlaskit/theme/colors';
import { rgba } from '../styles';
var smallLineHeight = 14;
var smallVerticalPadding = 4;
var smallHorizontalPadding = 8;
var largeLineHeight = 22;
var largeVerticalPadding = 8;
var largeHorizontalPadding = 12;
var responsiveStyleMap = {
  small: "_ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _4t3i14no",
  large: "_ca0qftgi _u5f31crf _n3tdftgi _19bv1crf _4t3i1wqb"
};
var HEX_REGEX = /^#[0-9A-F]{6}$/i;
var titleBoxWrapperStyles = null;
export var TitleBoxWrapper = function TitleBoxWrapper(props) {
  var breakpoint = props.breakpoint,
    titleBoxBgColor = props.titleBoxBgColor,
    hidden = props.hidden;
  var color = titleBoxBgColor && rgba(HEX_REGEX.test(titleBoxBgColor) ? titleBoxBgColor : N0, 1);
  return /*#__PURE__*/React.createElement("div", {
    id: "titleBoxWrapper",
    "data-testid": "media-title-box",
    className: ax(["_kqswstnw _94n5idpf _1bsb1osq _bfhkvuon _syaz1o8f _80om1kw7 _lcxvglyw _1e0c1txw _2lx21bp4 _1bah1h6o", responsiveStyleMap[breakpoint]]),
    style: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      backgroundColor: color,
      display: hidden ? 'none' : undefined,
      "--_ggxzyp": ix("var(--ds-text, ".concat(N800, ")"))
    }
  }, props.children);
};
TitleBoxWrapper.displayName = 'TitleBoxWrapper';
var infoStyles = null;
var iconOverlapStyle = null;
var titleBoxHeaderStyles = null;
export var TitleBoxHeader = function TitleBoxHeader(props) {
  var hasIconOverlap = props.hasIconOverlap;
  return /*#__PURE__*/React.createElement("div", {
    id: "titleBoxHeader",
    "data-testid": "title-box-header"
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    className: ax(["_k48p1pd9", "_1reo15vq _18m915vq _o5721q9c", hasIconOverlap && "_u5f319bv"])
  }, props.children);
};
TitleBoxHeader.displayName = 'FailedTitleBoxHeader';
var titleBoxFooterStyles = null;
export var TitleBoxFooter = function TitleBoxFooter(props) {
  var hasIconOverlap = props.hasIconOverlap;
  return /*#__PURE__*/React.createElement("div", {
    id: "titleBoxFooter",
    "data-testid": "title-box-footer"
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    className: ax(["_1bto1l2s", "_1reo15vq _18m915vq _o5721q9c", hasIconOverlap && "_u5f319bv"])
  }, props.children);
};
TitleBoxFooter.displayName = 'TitleBoxFooter';
var titleBoxIconStyles = null;
var newTitleBoxIconStyles = null;
export var TitleBoxIcon = function TitleBoxIcon(props) {
  return /*#__PURE__*/React.createElement("div", {
    id: "titleBoxIcon",
    "data-testid": "title-box-icon",
    className: ax([fg('platform-visual-refresh-icons') && "_kqswstnw _1xi21b66 _94n51b66", !fg('platform-visual-refresh-icons') && "_kqswstnw _1xi21b66 _94n5idpf"])
  }, props.children);
};
var errorMessageWrapperStyles = null;
export var ErrorMessageWrapper = function ErrorMessageWrapper(props) {
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulpv77o _1e0c1txw _4cvr1h6o _1bah1y6m _bozgv77o _e4kmnkob _1nm41b66 _184u1b66"])
  }, props.children);
};